const TYPE = 'ROCKY';

export const START_ROCKY_SSN_VERIFICATION = `${TYPE}/start_rocky_ssn_verification`;
export const START_ROCKY_MERGE_EXTRACTION = `${TYPE}/start_rocky_merge_extraction`;
export const RECALCULATE_POWER_SUM_WORKFLOW = `${TYPE}/recalculate_power_sum_workflow`;
export const REDRAW_STAT_EYE = `${TYPE}/redraw_stat_eye`;